import { actions } from './actions'

const initialState = {
  codigosPostalesInternacionales: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function codigosPostalesInternacionalesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CP_INTERNACIONALES_LOAD_REQUESTED:
      return {
        ...state,
        codigosPostalesInternacionales: { ...state.codigosPostalesInternacionales, loading: true },
      }
    case actions.CP_INTERNACIONALES_LOAD_SUCCEEDED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CP_INTERNACIONALES_LOAD_FILED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: false,
          error: action.error,
        },
      }
    case actions.CP_INTERNACIONAL_UPDATE_REQUESTED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: true,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_UPDATE_SUCCEEDED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          data: state.codigosPostalesInternacionales.data.map(pais =>
            pais.id === action.payload.id ? action.payload : pais,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_UPDATE_FILED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: false,
          error: action.error,
        },
      }
    case actions.CP_INTERNACIONAL_INSERT_REQUESTED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: true,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_INSERT_SUCCEEDED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          data: [].concat(action.payload, state.codigosPostalesInternacionales.data),
          loading: false,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_INSERT_FILED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: false,
          error: action.error,
        },
      }
    case actions.CP_INTERNACIONAL_DELETE_REQUESTED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: true,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_DELETE_SUCCEEDED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          data: state.codigosPostalesInternacionales.data.filter(
            pais => pais.id !== action.payload,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CP_INTERNACIONAL_DELETE_FILED:
      return {
        ...state,
        codigosPostalesInternacionales: {
          ...state.codigosPostalesInternacionales,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
